(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection.desktop-filter-bar"] && !Shopify.designMode) return;
  try {
    class CollectionDesktopFilterBar extends HTMLElement {
    connectedCallback() {
      this.boundHandleChange = this.handleChange.bind(this);
      this.boundHandleSubmit = this.handleSubmit.bind(this);
      this.boundHandleToggle = this.handleToggle.bind(this);
      this.boundHandleDocumentClick = this.handleDocumentClick.bind(this);

      this.addEventListener('change', this.boundHandleChange);
      this.addEventListener('submit', this.boundHandleSubmit);
      this.addEventListener('toggle', this.boundHandleToggle, true);
      document.addEventListener('click', this.boundHandleDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.boundHandleChange);
      this.removeEventListener('submit', this.boundHandleSubmit);
      this.removeEventListener('toggle', this.boundHandleToggle, true);
      document.removeEventListener('click', this.boundHandleDocumentClick);
    }

    handleChange(event) {
      if (!event.target.matches('[data-phs-filter-autosubmit]')) return;

      const form = event.target.closest('form');
      if (!form) return;

      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        this.prepareFormForSubmit(form);
        form.submit();
      }
    }

    handleSubmit(event) {
      this.prepareFormForSubmit(event.target);
    }

    handleToggle(event) {
      if (!event.target.matches('.collection-desktop-filter-bar__item[open]')) return;

      this.querySelectorAll('.collection-desktop-filter-bar__item[open]').forEach((details) => {
        if (details !== event.target) details.removeAttribute('open');
      });
    }

    handleDocumentClick(event) {
      if (this.contains(event.target)) return;

      this.querySelectorAll('.collection-desktop-filter-bar__item[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    }

    prepareFormForSubmit(form) {
      form.querySelectorAll('[data-phs-omit-empty]').forEach((input) => {
        if (input.value === '') input.disabled = true;
      });
    }
  }

  if (!customElements.get('collection-desktop-filter-bar')) {
    customElements.define('collection-desktop-filter-bar', CollectionDesktopFilterBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list.hot-reload"] && !Shopify.designMode) return;
  try {
    class ListHotReload extends HTMLElement {
    FORM_CHANGE_DEBOUNCE_DELAY = 800;
    CHANGE_TRIGGER_SELECTOR = '[data-change-trigger]';
    PAGINATION_SELECTOR = '[data-pagination-part-url]';
    URL_TO_REMOVE_SELECTOR = '[data-url-to-remove]';
    FEED_VIEW_SELECTOR = '[data-feed-view]';
    PRICE_MIN_PARAM_NAME = 'filter.v.price.gte';
    PRICE_MAX_PARAM_NAME = 'filter.v.price.lte';
    PRICE_RANGE_MIN_SELECTOR = `[name="${this.PRICE_MIN_PARAM_NAME}"]`;
    PRICE_RANGE_MAX_SELECTOR = `[name="${this.PRICE_MAX_PARAM_NAME}"]`;
    CHANGE_TRIGGER_TYPES = [
      'form',
      'form_filter',
      'form_select',
      'form_price_range_min',
      'form_price_range_max',
      'sort_select'
    ];

    constructor() {
      super();
      this.formChangeDebounce = null;
      this.cachedSections = [];
      this.abortController = null;
      this.fetchAbortController = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.id = this.getAttribute('id');
      this.sectionId = this.getAttribute('section-id');
      this.contextUrl = this.getAttribute('context-url');
      this.contextType = this.getAttribute('context-type');
      this.feedView = this.getAttribute('feed-view');

      if (!this.id || !this.contextUrl) {
        console.error('List hot reload: id or contextUrl is not set');
        return;
      }

      this.addEventListener('change', this.handleChange.bind(this), { signal: this.abortController.signal });
      this.addEventListener('list:price-range:slider-change', this.handleFormChange.bind(this), { signal: this.abortController.signal });
      this.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal });
      this.addEventListener('submit', this.handleSubmit.bind(this), { signal: this.abortController.signal });
      window.addEventListener('popstate', this.handlePopstate.bind(this), { signal: this.abortController.signal });

      this.initThemeEditorSupport();
    }

    disconnectedCallback() {
      clearTimeout(this.formChangeDebounce);
      this.fetchAbortController?.abort();
      this.abortController?.abort();
    }

    handleChange(event) {
      const changeTrigger = event.target.dataset.changeTrigger;

      if (!changeTrigger || !this.CHANGE_TRIGGER_TYPES.includes(changeTrigger)) {
        return;
      }

      switch (changeTrigger) {
        case 'sort_select':
          this.updateSortFromSelect(event.target);
          break;
        default:
          this.handleFormChange(event);
      }
    }

    handleFormChange(event) {
      const form = event.target.closest('form');

      if (!form) return;

      clearTimeout(this.formChangeDebounce);
      this.formChangeDebounce = setTimeout(() => {
        this.submitForm(form);
      }, this.FORM_CHANGE_DEBOUNCE_DELAY);
    }

    handleSubmit(event) {
      if (event.target.matches('[data-change-trigger="form"]')) {
        event.preventDefault();
        this.submitForm(event.target);
      }
    }

    handleClick(event) {
      const urlToRemoveBtn = event.target.closest(this.URL_TO_REMOVE_SELECTOR);
      const viewBtn = event.target.closest(this.FEED_VIEW_SELECTOR);
      const paginationBtn = event.target.closest(this.PAGINATION_SELECTOR);

      if (urlToRemoveBtn) {
        event.preventDefault();
        this.renderPage(urlToRemoveBtn.dataset.urlToRemove);
      } else if (viewBtn && viewBtn.dataset.feedView !== this.feedView) {
        event.preventDefault();
        this.updateFeedView(viewBtn.dataset.feedView);
      } else if (paginationBtn) {
        event.preventDefault();
        this.renderPage(paginationBtn.dataset.paginationPartUrl);
      }
    }

    handlePopstate(event) {
      this.renderPage(window.location.href, false);
    }

    updateSortFromSelect(select) {
      const currentParams = new URLSearchParams(window.location.search);
      const value = select.selectedOptions[0].value;

      // Filter out page param
      const filteredParams = Array.from(currentParams).filter(([key]) => {
        return key !== 'page';
      });
      const newParams = new URLSearchParams(filteredParams);

      newParams.set('sort_by', value);
      const paramsString = newParams.toString();
      const url = `${this.contextUrl}${this.contextUrl.includes('?') ? '&' : '?'}${paramsString}`;
      this.renderPage(url);
    }

    submitForm(form) {
      if (!form) return;
      const formData = new FormData(form);
      let newParams = new URLSearchParams(formData);

      // Remove price range params if they are the same as the default price range
      newParams = this.removeDefaultPriceRangeParams(form, newParams);

      // Fetch the page with the new params
      const paramsString = newParams.toString();
      const url = `${this.contextUrl}${this.contextUrl.includes('?') ? '&' : '?'}${paramsString}`;
      this.renderPage(url);
    }

    removeDefaultPriceRangeParams(form, params) {
      const gteInput = form.querySelector(this.PRICE_RANGE_MIN_SELECTOR);
      const lteInput = form.querySelector(this.PRICE_RANGE_MAX_SELECTOR);

      if (!gteInput || !lteInput) return params;

      const priceRangeMin = parseInt(gteInput.getAttribute('min'), 10);
      const priceRangeMax = parseInt(lteInput.getAttribute('max'), 10);
      const gteValue = parseInt(params.get(this.PRICE_MIN_PARAM_NAME), 10);
      const lteValue = parseInt(params.get(this.PRICE_MAX_PARAM_NAME), 10);

      if (gteValue === priceRangeMin && lteValue === priceRangeMax) {
        params.delete(this.PRICE_MIN_PARAM_NAME);
        params.delete(this.PRICE_MAX_PARAM_NAME);
      }

      return params;
    }

    updateFeedView(feedView) {
      this.updateAttribute('feed_view', feedView).then(() => {
        const url = new URL(window.location.href);

        this.feedView = feedView;
        url.searchParams.delete('page');
        this.renderPage(url.toString());
      }).catch((error) => {
        console.error('Failed to update feed view:', error);
        throw error;
      });
    }

    updateAttribute(key, value) {
      this.resetFetchAbortController();
      
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
        signal: this.fetchAbortController.signal,
      }).then((response) => {
          if (!response.ok) throw response;
          return response.json();
      }).catch((error) => {
        if (error.name === 'AbortError') throw error;
        console.error('Failed to update cart attribute:', error);
        throw error;
      });
    }

    renderPage(url, updateURLHash = true) {
      const fullUrl = new URL(url, window.location.origin).toString();

      this.showLoadingState();
      this.scrollToTop();

      return this.renderSectionFromCache(fullUrl).catch(() => {
        return this.renderSectionFromFetch(fullUrl);
      }).then(() => {
        if (updateURLHash) this.updateURLHash(fullUrl);

        // Dispatch custom event for other components to react
        this.dispatchEvent(
          new CustomEvent('list:hot-reload:updated', {
            bubbles: true,
            detail: { context: this.contextType },
          })
        );

        this.hideLoadingState();
      }).catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('Failed to render page:', fullUrl, error);
        this.hideLoadingState();
        throw error;
      });
    }

    scrollToTop() {
      if (this.getBoundingClientRect().y >= 0) return;
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    updateURLHash(url) {
      const currentUrl = new URL(window.location);
      const newUrl = new URL(url, window.location.origin);

      if (currentUrl.pathname !== newUrl.pathname || currentUrl.search !== newUrl.search) {
        window.history.pushState({}, '', newUrl.toString());
      }
    }

    renderSectionFromCache(url) {
      const cachedSection = this.cachedSections.find((cachedSection) => {
        return cachedSection.url === url && cachedSection.feedView === this.feedView;
      });
      if (!cachedSection) return Promise.reject();

      this.renderSection(cachedSection.html);
      return Promise.resolve(cachedSection.url);
    }

    renderSectionFromFetch(url) {
      return this.fetchPage(url).then((sectionHtml) => {
        this.renderSection(sectionHtml);
      });
    }

    renderSection(sectionHtml, section) {
      const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const newContent = html.getElementById(this.id);

      this.textContent = "";

      // Range insertion to preserve declarative shadow DOM
      const range = document.createRange();
      range.selectNodeContents(this);
      range.collapse(true);
      Array.from(newContent.childNodes).forEach(node => {
        range.insertNode(node);
        range.setStartAfter(node);
      });
    }

    fetchPage(url) {
      const sectionUrl = new URL(url, window.location.origin);
      const cacheUrl = sectionUrl.toString();

      // Add section id to the url
      sectionUrl.searchParams.set('sections', this.sectionId);

      this.resetFetchAbortController();

      return fetch(sectionUrl.toString(), {
        signal: this.fetchAbortController.signal,
      }).then((response) => {
        if (!response.ok) throw response;
        return response.json();
      }).then((sectionsData) => {
        const sectionHtml = sectionsData[this.sectionId];
        this.cachedSections.push({ 
          url: cacheUrl,
          html: sectionHtml,
          feedView: this.feedView
        });
        return sectionHtml;
      }).catch((error) => {
        if (error.name === 'AbortError') throw error;
        console.error('Failed to fetch page:', error);
        throw error;
      });
    }

    resetFetchAbortController() {
      this.fetchAbortController?.abort();
      this.fetchAbortController = new AbortController();
    }

    showLoadingState() {
      this.setAttribute('loading', '');
    }

    hideLoadingState() {
      this.removeAttribute('loading');
    }

    initThemeEditorSupport() {
      if (!window.Shopify?.designMode) return;

      // Clear feed_view cart attribute when section is re-rendered in theme editor
      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail?.sectionId !== this.sectionId) return;
        this.updateAttribute('feed_view', '');
      });
    }
  }

  customElements.define('list-hot-reload', ListHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      // TODO: replace with dialog element
      // this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.removeAttribute('inert');
      this.trapFocus(this);
    }
    
    close() {
      this.setAttribute('open', 'false');
      this.setAttribute('inert', '');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

})();
